import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styles from "./index.module.sass";
import { CompetitionsType, CompetitionType, CompetitionTypes } from "../../services/CompetitionsService";
import { currencyNeutreFormatter } from "../../utils/numberFormatter";
import { PrimaryButton } from "@fluentui/react";
import Auth from "../../Auth/Auth";
import { ErrorModal } from "../Modals/ErrorModal";
import { createurl } from "../../utils/createUrl";

interface CompetitionCardProps
{
	competition: CompetitionType
	toJoin?: boolean;
	idCompetition?: number
}

const CompetitionCardFromCompetition: React.FC<CompetitionCardProps> = ({
	competition,
	toJoin,
	idCompetition
}) =>
{
	const history = useHistory();
	const isUserSuscribed = Auth.isSubscribed();
	const activePlan = Auth.getActivePlan();

	const [error, setError] = useState({ status: false, message: "" });

	const formatDate = (date: string) =>
	{
		const [month, day, year] = date.split("/");
		return `${day}/${month}/${year}`;
	};


	function truncateHtml(html: string, limit: number): string
	{
		const textContent = html.replace(/<\/?[^>]+(>|$)/g, ""); // Elimina etiquetas HTML
		if (textContent.length > limit)
		{
			const truncatedText = textContent.substring(0, limit) + "...";
			return truncatedText;
		}
		return textContent;
	}


	return (
		<article
			className={`rounded background-background`}
			style={{
				marginRight: "20px",
				boxShadow: "0 0 5px 3px rgb(0 0 0 / 8%)",
				paddingTop: "10px",
				paddingLeft: "16px",
				paddingRight: "16px",
				height: "240px",
				width: "390px"
			}}
		>
			<Link
				to={
					toJoin !== true
						? {
							pathname: competition.isPromocionated
								? `/competition/${createurl(competition.name)}-${idCompetition}`
								: `/competitions/${idCompetition}`,
							state: { competitionId: idCompetition },
						}
						: {
							pathname: "",
							state: { competitionId: idCompetition },
						}
				}
				onClick={(e) =>
				{
					if (toJoin === true) e.preventDefault();
				}}
				className="color-black"
			>

				<header>
					<div
						style={{
							display: "flex",
							marginTop: "10px",
							height: "50px",
							alignContent: "center",
							justifyContent: "space-between",
						}}
					>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<p
								style={{
									marginBottom: "0px",
									fontSize: "16px",
									fontWeight: "600",
									wordBreak: "break-word",
								}}
							>
								{competition.name}
							</p>
							<span className="color-neutralTertiaryAlt">
								Del {formatDate(competition.startDate)} al {formatDate(competition.endDate)}
							</span>
						</div>
						<span className={styles.type}>
							Tipo: {CompetitionTypes[competition.type]}
						</span>
					</div>
				</header>
				<main
					style={{
						marginTop: "10px",
						whiteSpace: "normal",
						height: "100px"
					}}
					dangerouslySetInnerHTML={{
						__html: truncateHtml(competition.summary ?? "", 400),
					}}
				/>
			</Link>
			<div
				style={{
					position: "relative",
					width: "100%",
					height: "190px",
				}}
			>
				<footer
					style={{
						backgroundColor: "white",
						width: "100%",
						fontSize: "14px",
						fontWeight: "500",
						display: "flex",
						justifyContent: "space-between",
						boxSizing: "border-box",
					}}
				>
					<div>
						<span>
							{competition.price === 0 && <>Inscripción gratuita</>}
							{competition.price !== 0 && competition.typeOfPrice === 0 && <>{currencyNeutreFormatter.format(competition.price)} Elements IA</>}
							{competition.price !== 0 && competition.typeOfPrice === 1 && <>{currencyNeutreFormatter.format(competition.price)} Elements Agua</>}
							{competition.price !== 0 && (competition.typeOfPrice === 2 || competition.typeOfPrice === 3) && <>{currencyNeutreFormatter.format(competition.price)} €</>}
						</span>
						{competition.price != 0 && <> <p>Participantes: {competition.isPromocionated == true ? competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length : competition.competitionsUsers.length}</p>
							<p className={styles.price}>
								Bote:{" "}
								{competition.typeOfPrice === 0 &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} Elements IA </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} Elements IA</>}
									</>
								}
								{competition.typeOfPrice === 1 &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} Elements Agua </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} Elements Agua</>}
									</>
								}
								{(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} € </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} €</>}
									</>
								}
							</p></>}
					</div>
					{toJoin !== true && <PrimaryButton
						className="rounded"
						onClick={() =>
						{
							if (activePlan.type == 0)
							{
								setError({ status: true, message: "Los planes de tipo gestionado no pueden participar en la competición. Actualmente tienes seleccionado como activo un plan de este tipo." })
							} else
							{
								isUserSuscribed
									? history.push(`/competitions/join/${idCompetition}`)
									: history.push(`/competitions/join/nsv/${idCompetition}`
									);
							}
						}}
					>
						Participar
					</PrimaryButton>}

				</footer>
				{/* {competition.price !== 0 && (
                    <footer
                        style={{
                            backgroundColor: "white",
                            width: "100%",
                            fontSize: "14px",
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            boxSizing: "border-box",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            paddingTop: "20px",
                            position: "absolute",
                            bottom: "20px",
                        }}
                    >
                        
                    </footer>
                )} */}
			</div>
			<ErrorModal
				title="Tu Plan actual no es compatible con la competición"
				body={
					<div>
						<p>{error.message}</p>
					</div>
				}
				btnSubmitText="Aceptar"
				showModal={error.status}
				onSubmit={() =>
				{
					setError({ status: false, message: "" });
				}}
				onClose={() =>
				{
					setError({ status: false, message: "" });
				}}
			/>
		</article>
	);
};

export default CompetitionCardFromCompetition;
